import { useEffect, useState } from "react";
import { ShieldCheck, User, Handshake, Network as NetIcon } from "lucide-react";
import { Panel } from "@/components/common";
import { UserAvatar } from "@/components/UserAvatar";
import { api } from "@/lib/api";

const GROUPS = [
  ["admins", "Amministratori", ShieldCheck, (u) => u.role === "admin" && !u.is_partner],
  ["partners", "Soci", Handshake, (u) => u.is_partner],
  ["employees", "Dipendenti", User, (u) => u.role !== "admin" && !u.is_partner],
];

function Member({ u, partnerName }) {
  return (
    <li className="flex items-center gap-3 px-4 py-2.5 text-sm" data-testid={`network-member-${u.id}`}>
      <UserAvatar fileId={u.avatar_file_id} name={u.name} />
      <span className="min-w-0 flex-1">
        <span className="block truncate font-medium">{u.name}{!u.active && <span className="ml-1.5 text-xs font-normal text-muted-foreground">(disattivato)</span>}</span>
        <span className="block truncate text-xs text-muted-foreground">{[u.is_partner && u.role === "admin" ? "Amministratore" : "", u.role === "manager" ? "Responsabile" : "", u.job_title, u.department].filter(Boolean).join(" · ") || u.email}</span>
        {partnerName && <span className="block truncate text-xs text-primary">Referente: {partnerName}</span>}
      </span>
    </li>
  );
}

export function NetworkPanel({ q = "" }) {
  const [users, setUsers] = useState(null);
  const [org, setOrg] = useState(null);
  useEffect(() => {
    api.get("/admin/users").then((r) => setUsers(r.data));
    api.get("/org").then((r) => setOrg(r.data));
  }, []);
  if (!users) return null;
  const names = Object.fromEntries(users.map((u) => [u.id, u.name]));
  const ql = q.trim().toLowerCase();
  const match = (u) => !ql || `${u.name} ${u.email} ${u.department || ""} ${u.job_title || ""}`.toLowerCase().includes(ql);
  return (
    <Panel title={`La mia rete${org ? ` · ${org.name}` : ""}`} testId="dashboard-network">
      <div className="flex items-center gap-2 border-b px-5 py-3 text-xs text-muted-foreground">
        <NetIcon className="h-4 w-4 text-primary" />
        <span data-testid="network-total">{users.length} membri</span>
        {org && <span className="ml-auto font-mono" translate="no">{org.code}</span>}
      </div>
      <div className="grid divide-y md:grid-cols-3 md:divide-x md:divide-y-0">
        {GROUPS.map(([key, label, Icon, fn]) => {
          const list = users.filter((u) => fn(u) && match(u));
          return (
            <div key={key} data-testid={`network-group-${key}`}>
              <p className="flex items-center gap-2 px-4 pt-4 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                <Icon className="h-4 w-4 text-primary" />{label}
                <span className="ml-auto rounded-full bg-primary/10 px-2 py-0.5 text-primary" data-testid={`network-count-${key}`}>{list.length}</span>
              </p>
              {list.length === 0 ? <p className="px-4 py-4 text-xs text-muted-foreground">Nessuno</p> : (
                <ul className="max-h-72 overflow-y-auto py-2">
                  {list.map((u) => <Member key={u.id} u={u} partnerName={key === "employees" ? names[u.reference_partner_id] : null} />)}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
